<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<router-outlet></router-outlet>